let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3B8DW")).then(() => parcelRequire('19LO5'));